import { useTheme } from 'styled-components';

import { IconProps } from '~types/icon';

export default function Check({ width = 12, height = 10, color }: IconProps) {
  const theme = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 12 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.99993 7.80007L1.19993 5.00006L0.266602 5.9334L3.99993 9.66673L11.9999 1.66673L11.0666 0.733398L3.99993 7.80007Z'
        fill={color || theme.colors.gray900}
      />
    </svg>
  );
}
